module.exports = __webpack_public_path__ + "static/img/logo_blue.85943f09.png";